<template>
    <div class="table-deja-payé">
        <!-- Affichage des acomptes -->
        <div v-if="c_order && c_order.invoices?.length > 0" class="px-3 pt-2 border rounded-4 mt-4 mb-2">
            <div class="cv3-deposit-row ppv2-mb-4">
                <div class="cv3-deposit-card cv3-deposit-paid">
                    <span class="cv3-deposit-label">{{
                        $t('checkout.v3.already_paid_label') || $t('checkout.v3.already_paid') || 'Déjà payé'
                    }}</span>
                    <span class="cv3-deposit-amount poppinsSemiBold ppv2-text-lg">{{ formatPrice(alreadyPaid) }} €</span>
                </div>
                <div class="cv3-deposit-card cv3-deposit-remains">
                    <span class="cv3-deposit-label">{{ $t('checkout.v3.remaining_to_pay_label') || 'Reste à payer' }}</span>
                    <span class="cv3-deposit-amount poppinsSemiBold ppv2-text-lg">{{ formatPrice(c_remainPrice) }} €</span>
                </div>
            </div>

            <table class="table table-striped table-vcenter w-100">
                <tbody>
                    <tr v-for="(item, index) in invoices" :key="index">
                        <td class="fw-normal fs-sm ppv2-text-black">{{ parseDate(item.created_at, 'lll') }}</td>
                        <td>
                            <!-- item.payment_method.name === 'cure' ? 'forfait' : -->
                            <!-- payment_method est nullable : sans garde, un règlement dont le moyen de
                                 paiement n'a pas été résolu faisait planter le render et TOUT le bloc
                                 « Déjà payé » disparaissait. Mieux vaut afficher la ligne trouée. -->
                            <span class="fw-normal fs-sm ppv2-text-black">{{ item.payment_method?.display_name || '—' }}</span>
                            <br />
                            <span class="fw-normal fs-sm ppv2-text-black" v-if="item.voucher_id">({{ item.voucher }})</span>
                        </td>
                        <td class="fw-normal fs-sm ppv2-text-black">
                            {{ parseFloat(item.amount).toFixed(2) }}{{ $symbolCurrency }}
                        </td>
                        <td v-if="item.amount > 0" class="fw-normal fs-sm ppv2-text-black text-end">
                            <PaymentRefound :item="item"></PaymentRefound>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { get } from 'vuex-pathify'
import PaymentRefound from './PaymentRefound.vue'
import FingerprintChange from './FingerprintChange.vue'
import axios from 'axios'

export default {
    components: { PaymentRefound, FingerprintChange },
    props: ['orderObj'],
    data: () => ({
        invoices: [],
    }),
    created() {},
    computed: {
        ...get('overlay@data', {
            c_order: 'order',
            c_remainPrice: 'remainPrice',
        }),
        alreadyPaid() {
            if (!this.c_order) return 0
            const total = parseFloat(this.c_order.total) || 0
            const remain = parseFloat(this.c_remainPrice) || 0
            return Math.max(0, total - remain)
        },
    },
    methods: {
        getVoucherCode(id) {
            return axios.get(`/back-office/caisse/getVoucherCode/${id}`).then((res) => res.data)
        },
        stringify(val) {
            return JSON.stringify(val)
        },
        parseDate(date, format) {
            return moment(date).locale(this.$i18n.locale).format(format)
        },
        formatPrice(v) {
            return (Math.round((Number(v) || 0) * 100) / 100).toFixed(2).replace('.', ',')
        },
    },
    watch: {
        c_remainPrice(val) {
            if (this.closeSale && val !== '0.00') {
                this.closeSale = false
            }
        },
        usedFidelityPoints(newVal) {
            this.$emit('used-fidelity-points', newVal)
        },

        'c_order.invoices': {
            immediate: true,
            deep: true,
            async handler(val) {
                if (!val) return

                const copy = []
                for (let i = 0; i < val?.length; i++) {
                    const elem = val[i]
                    if (elem.voucher_id) elem.voucher = await this.getVoucherCode(elem.voucher_id)
                    copy.push(elem)
                }
                this.invoices = copy.reverse()
            },
        },
    },
}
</script>

<style scoped>
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
.theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > tbody
    > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: transparent !important;
}
</style>
<style scoped>
#promo-code-select {
    margin: 15px 0px;
    width: 100%;
}
select#promo-code-select {
    height: 40px;
    font-size: clamp(12px, 0.729545vw, 16px);
    padding-top: 9px;
    border-radius: 7px;
}
.btn-dark-appli {
    font-size: 16px !important;
    padding-left: 26px !important;
    padding-right: 26px !important;
    height: 38px !important;
    line-height: 24px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
}
.btn-green-appli {
    color: #fff !important;
    background: #46d5b3;
    font-size: 16px !important;
    padding-left: 26px !important;
    padding-right: 26px !important;
    height: 38px !important;
    line-height: 24px !important;
    border-radius: 8px !important;
    font-weight: 500 !important;
    border: solid 1px #46d5b3;
}
.form-control,
.form-select {
    border-radius: 8px;
    height: 40px;
    /*padding-top: 8px;*/
    font-size: clamp(12px, 0.729545vw, 16px);
}
.rest-du {
    background: #7d2dbd;
    border-radius: 4px;
    padding: 5px 12px;
    height: 32px !important;
}
.box-amount {
    font-weight: 400px;
    font-size: 12px;
    padding: 2px 17px;
    border-radius: 4px;
    background: #46d5b3;
    color: white;
}
.some-amount {
    border: solid 1px #7b8289;
    border-radius: 8px;
    padding: 4px 8px;
    width: 80%;
}
.title-some-am {
    border-bottom: solid 1px #7d2dbd;
}
#toggleButton {
    cursor: pointer;
    transition: transform 0.3s;
}
.disable-focus:focus {
    border-color: none !important;
    box-shadow: none !important;
}
.cv3-deposit-row {
    display: flex;
    gap: 8px;
    margin-top: 10px;
    margin-bottom: 15px;
}
.cv3-deposit-card {
    flex: 1 1 0;
    border-radius: 12px;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.cv3-deposit-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
}

.cv3-deposit-paid {
    background: rgba(74, 222, 128, 0.12);
    border: 1px solid rgba(74, 222, 128, 0.2);
}
.cv3-deposit-paid .cv3-deposit-label {
    color: #4ade80;
}
.cv3-deposit-paid .cv3-deposit-amount {
    color: #4ade80;
}

.cv3-deposit-remains {
    background: #021832;
    border: 1px solid rgba(255, 255, 255, 0.1);
}
.cv3-deposit-remains .cv3-deposit-label {
    color: rgba(255, 255, 255, 0.6);
}
.cv3-deposit-remains .cv3-deposit-amount {
    color: #ffffff;
}
</style>
